import React, {useState} from 'react'
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useCalcContext} from "../../contexts/CalcContext";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircularProgress from '@mui/material/CircularProgress';
import useDidMountEffect from "../../hooks/useDidMountEffect";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {LEASE_DEAL_LIGHT} from "../../contexts/DealContext";
import Tooltip from "@mui/material/Tooltip";
import classnames from "classnames";

const nextYear = new Date().getFullYear() + 1
const allYears = Array.from({ length: nextYear - 2015 + 1 }, (_, i) => String(2015 + i));
const newYears = allYears.slice(-3)

export const CalcSelectCar = () => {
    const {
        carState,
        setCarState,
        getMakesForYear,
        getMakesForYearResponse,
        getModelsForMake,
        getModelsForMakeResponse,
        getTrimsForModelResponse,
        getTrimsForModel,
        getCarByVinResponse,
        calcState,
        setCalcState,
        isUsed,
        setIsUsed,
    } = useCalcContext()

    const [isTrimSelectOpen, setIsTrimSelectOpen] = useState(false)

    const getIcon = (isLoading, props) => {
        const isFullLoading = getCarByVinResponse?.loading || isLoading
        return isFullLoading ? <CircularProgress {...props} size={13} style={{marginRight: '6px', marginTop: '3px'}}/> :
            <ArrowDropDownIcon {...props}/>
    }

    useDidMountEffect(function openTrimSelectIfMultipleCars(){
        if (carState.vin_vehicles.length > 1) {
            setIsTrimSelectOpen(true)
        }
    }, [carState.vin_vehicles])

    const isTrimInVinVehicles = (trimId) => {
        const vinVechileIds = carState.vin_vehicles.map(v => String(v.id))
        return vinVechileIds.includes(String(trimId))
    }

    const isRebatesDisabled = !calcState.base_car_id || !calcState.location_id || !calcState.dealer_location_id

    const { makes, models, trims, options } = carState

    const years = isUsed ? allYears : newYears

    return (
        <Box className={'panel'}>
            <div className="panel-header">
                <div className="panel-title">
                    <svg viewBox="0 0 24 24" fill="currentColor" style={{width:16, height:16}}>
                        <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                    </svg>
                    Select Car
                </div>
                <div className="tab-toggle">
                    <button
                        className={classnames('tab-btn', { active: !isUsed })}
                        onClick={() => setIsUsed(false)}
                        type="button"
                    >
                        New
                    </button>
                    <button
                        className={classnames('tab-btn', { active: isUsed })}
                        onClick={() => setIsUsed(true)}
                        type="button"
                    >
                        Used
                    </button>
                </div>
            </div>
            <div className="panel-body">
                <div className={'form-row'}>
                    <label>Year</label>
                    <Select
                        className={'Select'}
                        labelId="pricing-select-year"
                        id="year-select"
                        value={carState.year}
                        label="Year"
                        IconComponent={(props) => getIcon(false, props)}
                        onChange={(e) => {
                            const year = e.target.value
                            setCarState({
                                ...carState,
                                year: year,
                                make: '',
                                model: '',
                                trim: '',
                                options: []
                            })
                            setCalcState({...calcState, vin: ''})
                            getMakesForYear(isUsed)
                        }}
                    >
                        {
                            years.map((year) => <MenuItem key={year} value={year}>{year}</MenuItem>)
                        }
                    </Select>
                </div>
                <div className={'form-row'}>
                    <label>Make</label>
                    <Select
                        className={'Select'}
                        IconComponent={(props) => getIcon(getMakesForYearResponse?.loading, props)}
                        value={carState.make}
                        disabled={!carState.year || !carState.makes.length}
                        onChange={(e) => {
                            const make = e.target.value
                            setCarState({
                                ...carState,
                                make: make,
                                model: '',
                                trim: '',
                                options: []
                            })
                            setCalcState({...calcState, vin: ''})
                            getModelsForMake(carState.year, make, isUsed)
                        }}
                    >
                        {
                            makes.map((make) => <MenuItem key={make.cleaned_name} value={make.cleaned_name}>{make.cleaned_name}</MenuItem>)
                        }
                    </Select>
                </div>
                <div className={'form-row'}>
                    <label>Model</label>
                    <Select
                        className={'Select'}
                        IconComponent={(props) => getIcon(getModelsForMakeResponse?.loading, props)}
                        value={carState.model}
                        disabled={!carState.make || !carState.models.length}
                        onChange={(e) => {
                            const model = e.target.value
                            setCarState({
                                ...carState,
                                model: model,
                                trim: '',
                                options: []
                            })
                            setCalcState({...calcState, vin: ''})
                            getTrimsForModel(carState.year, carState.make, model, isUsed)
                        }}
                    >
                        {
                            models?.map((model) => <MenuItem key={model.name} value={model.cleaned_name}>{model.cleaned_name}</MenuItem>)
                        }
                    </Select>
                </div>
                <div className={'form-row'}>
                    <label>Trim</label>
                    <Select
                        className={'Select'}
                        value={carState.trim}
                        onClose={() => setIsTrimSelectOpen(false)}
                        onOpen={() => setIsTrimSelectOpen(true)}
                        open={isTrimSelectOpen}
                        disabled={!carState.model|| !carState.trims.length}
                        IconComponent={(props) => getIcon(getTrimsForModelResponse?.loading, props)}
                        onChange={(e) => {
                            const trim = JSON.parse(e.target.value)
                            const last_deal_data = trim.last_deal_data
                            setCarState({
                                ...carState,
                                trim: JSON.stringify(trim),
                                options: trim.option_codes,
                                car_id: trim.id,
                                base_car_id: trim.id,
                            })
                            setCalcState({
                                ...calcState,
                                car_id: trim.id,
                                base_car_id: trim.id,
                                msrp: last_deal_data?.msrp,
                                cost: last_deal_data?.cost,
                            })
                            setTimeout(() => {
                                setIsTrimSelectOpen(false)
                            }, 0)
                        }}
                    >
                        {
                            trims?.map((trim) =>
                                <MenuItem
                                    key={trim.id}
                                    value={JSON.stringify(trim)}
                                    sx={{
                                        backgroundColor: isTrimInVinVehicles(trim.id) ? "rgba(0, 0, 0, 0.04)" : "inherit"
                                    }}
                                >
                                    {trim.name}<span style={{fontSize: '11px', marginLeft: '5px'}}> [{trim.manufacture_code}]</span>
                                </MenuItem>)
                        }
                    </Select>
                </div>
                {
                    Boolean(carState.options.length) &&
                    <div className={'form-row'}>
                        <Tooltip
                            title={'Option codes are not necessary but can affect rebates.'}
                            arrow placement={'right'}
                        >
                            <label>
                                Options
                                <InfoOutlinedIcon
                                    sx={{
                                        color: LEASE_DEAL_LIGHT,
                                        fontSize: '19px',
                                        marginLeft: '5px'
                                    }}
                                />
                            </label>
                        </Tooltip>
                        <Select
                            className={'Select'}
                            multiple={true}
                            IconComponent={(props) => getIcon(getModelsForMakeResponse?.loading, props)}
                            value={carState.option_codes}
                            disabled={!carState.make || !carState.models.length || !carState.trims.length}
                            onChange={(e) => {
                                const option_codes = e.target.value
                                setCarState({
                                    ...carState,
                                    option_codes: option_codes
                                })
                                const option_code_ids = option_codes.map(c => c.id)
                                setCalcState({...calcState, option_code_ids: option_code_ids})
                            }}
                        >
                            {
                                options?.map((option) => <MenuItem key={option.id} value={option}>{option.name}</MenuItem>)
                            }
                        </Select>
                    </div>
                }
                <div className={'or-divider'}>Or</div>
                <div className={'form-row'}>
                    <label>Vin</label>
                    <input
                        type="text"
                        value={calcState.vin}
                        placeholder={'Enter a Vin'}
                        onChange={(e) => {
                            setCalcState({...calcState, vin: e.target.value})
                        }}
                    />
                </div>
            </div>
        </Box>
    )
}